//이 tsx파일은 정적 로딩을 위주로 하니 수정한다고 하더라도 바로 반영되지 않을수 있다.

import { forwardRef, memo, MouseEvent, useImperativeHandle } from "react";
import { CellStyle, RowStyle } from "ag-grid-community";
// DTO import (만약 아직 없다면 추가)
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { FileForm } from "./form/FileForm";
import { SwitchButtonForm } from "./form/SwitchButtonForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";

// 공통 타입 정의 추가
export type AnyDto = CompanyDto | ItemDto | SysCodeDto | OrganizationDto | WareHouseDto | WorkPlaceDto;

//ag-grid 이벤트 핸들러 타입 - \components\common\gridWrapper\.. 에서 사용
export type HandledProps = 'onGridReady' | 'onCellMouseOver' | 'onCellMouseOut' | 'onColumnMoved' | 'onColumnPinned' | 'onColumnVisible' | 'onColumnResized' | 'onSortChanged';

// 공통변수 저장
export const idLength = 20;
export const pwLength = 20;

//homecontainer에 배치할 최소 width 크기, 이후 각 tab, info, modal에 각 클래스를 주입
export const MinWidthNumber = 860;
export const MinWidthString = MinWidthNumber.toString();
export const MinWidthWrapper = 'min-w-[' + MinWidthString + 'px]';
// MinWidthNumber에서는 숫자와 문자열을 조합해서 css를 설정할때, 해당 css를 제대로 인식하지 못하는 문제가 있어서,
// MinWidthNumber, MinWidthWrapper 을 수정할때 이 값도 제대로 수정해야 원하는 결과를 얻을 확률이 높다
export const staticMinWidthWrapper = 'min-w-[860px]';


//액션바 최소너비, 아마 검색조건 칸까지 영향을 받을거다
export const actionBarMinWidthWrapper = 'min-w-[600px]';

export const commonBorderString = '1px solid #AEAEB2';
export const commonBorderStyle: CellStyle = { borderRight: commonBorderString };
export const pointerStyle: CellStyle = { cursor: 'pointer' };
export const commonPointerCellStyle: CellStyle = { ...commonBorderStyle, ...pointerStyle };
export const disabledBorderString = '1px solid rgb(72, 72, 72)';
export const disabledBorderStyle: CellStyle = { border: disabledBorderString };

export const defaultInputFormString = 'flex gap-x-[24px] gap-y-[6px] ';

//검색 칸의 각 input 컴포넌트 form 스타일
// export const searchFormString = 'flex items-center h-[90%] gap-[8px] bg-white-100 border border-gray-200 px-[12px] rounded-[6px] ';
export const searchFormString = 'flex items-center h-[90%] gap-[6px] bg-white-100 px-[12px] rounded-[6px] ';
export const dateRangePickerFormString = 'flex items-center gap-[0px] bg-white-100 rounded-[6px] ';

export const searchFormDefaultString = 'border border-gray-300 ';

export const searchInputFormString = searchFormDefaultString + 'px-[6px] w-full h-[24px] rounded-[6px] pr-8';
export const searchDateSingleFormString = searchFormDefaultString + 'py-[2px] text-center flex-1 h-[24px] rounded-[6px] ';
export const searchDateRangeFormString = searchFormDefaultString + 'py-[2px] text-center w-full h-[24px] rounded-[6px] p-2 whitespace-nowrap overflow-hidden text-ellipsis';
export const dateRangePickerFieldString = searchFormDefaultString + 'py-[0px] px-[10px] text-center w-full h-[20px] rounded-[6px] whitespace-nowrap overflow-hidden text-ellipsis';
export const searchCodeModalFormString = searchFormDefaultString + 'px-[6px] w-[80px] h-[24px] text-left rounded-[6px]';

// 검색 필드 공통 너비 설정
export const searchFieldWidth = 'w-[300px] min-w-[300px]';
export const dateRangePickerFieldWidth = 'w-[400px] min-w-[400px] mb-[4px]';
// 검색 폼 Label 공통 스타일 (45px 고정 너비)
export const searchLabelStyle = 'h-[24px] flex items-center truncate shrink-0';
export const dateRangePickerFormLabelStyle = 'h-[20px] flex items-center truncate shrink-0 w-[100px] min-w-[100px]';
export const blueButtonClass = 'bg-blue-dark hover:bg-blue-600';
export const grayButtonClass = 'bg-gray-400 cursor-not-allowed';


export const inputFormString20p = 'w-[20%]'; export const inputFormStyle20p 	= 	defaultInputFormString + ' ' + inputFormString20p;
export const inputFormString25p = 'w-[25%]'; export const inputFormStyle25p 	= 	defaultInputFormString + ' ' + inputFormString25p;
export const inputFormString33p = 'w-[33%]'; export const inputFormStyle33p 	= 	defaultInputFormString + ' ' + inputFormString33p;
export const inputFormString50p = 'w-[50%]'; export const inputFormStyle50p 	= 	defaultInputFormString + ' ' + inputFormString50p;
export const inputFormString66p = 'w-[66%]'; export const inputFormStyle66p 	= 	defaultInputFormString + ' ' + inputFormString66p;
export const inputFormString75p = 'w-[75%]'; export const inputFormStyle75p 	= 	defaultInputFormString + ' ' + inputFormString75p;
export const inputFormString80p = 'w-[80%]'; export const inputFormStyle80p 	= 	defaultInputFormString + ' ' + inputFormString80p;
export const inputFormString90p = 'w-[90%]'; export const inputFormStyle90p 	= 	defaultInputFormString + ' ' + inputFormString90p;
export const inputFormString95p = 'w-[95%]'; export const inputFormStyle95p 	= 	defaultInputFormString + ' ' + inputFormString95p;
export const inputFormString99p = 'w-[99%]'; export const inputFormStyle99p 	= 	defaultInputFormString + ' ' + inputFormString99p;
export const inputFormString100p = 'w-[full]'; export const inputFormStyle100p 	= 	defaultInputFormString + ' ' + inputFormString100p;

export const titleMRClass = 'mr-[4px]';
export const titleAddressMRClass = 'mr-[4px]';
export const titleAddressMBClass = 'mb-[5px]';


export const inputAddressMRClass = 'mr-[4px]';
export const inputAddressMBClass = 'mb-[5px]';
export const inputMRClass = 'mr-[10px]';
export const inputMBClass = 'mb-[10px]';

export const disableColor = '#F0F0F0';
export const warningColor = '#f1843b';
export const pointerParam = 'pointer';

export const selectedColor = '#C4C9DD';
export const hoverColor = '#E1E8FF';
export const insertedColor = '#D1FADF';
export const modifiedColor = '#f8d2ab';
export const deletedColor = '#f9cdcd';

export const gridCalendarWidth = '100vw';
export const gridCalendarLayoutHeight = '100vh';
export const gridCalendarHeight = '230px';

export const defaultDateString = '1900-01-01T00:00:00+09:00';
export const defaultValidateDateString = defaultDateString;
export const defaultWorkTimeResetDate = Date.parse('1900-01-01T00:00:00.000Z');
export const inputFormHeightOption = '';
export const inkoNpmOption = {
	allowHash: false,
	allowSpace: false,
};

export const commonTextAlignStyle: CellStyle = { textAlign: 'right' };

export const commonBottomRowStyle: RowStyle = { background: '#F0F0F0', fontWeight: 'bold', borderTop: 'none' };

export const aggridHeaderClass = 'ag-header-cell-label-center';

export const aggridSwitchButtonWrapperStyle = {
	wrapperStyle: "w-full m-0 p-0", titleStyle: "text-left", inputStyle: "w-full flex justify-center"
}

export const aggridFileFormWrapperStyle = {
	wrapperStyle: "w-full m-0 p-0", titleStyle: "text-left", inputStyle: "w-full flex justify-center"
}

//입력 그리드에서 품목 코드 - 품목 정보 입력 시 허용 품목 계정
export const ALLOWED_COORDINATE_ACCOUNTS = '100,200';
export const ALLOWED_ITEM_ACCOUNTS = '100,200,400';
export const allowedAccountsArr = ['100', '200', '400'];

export const BRDiv = () => { return (<div className="w-full h-[1px]"></div>); }

// SearchSection용 구분 공간 - 시각적 구분을 위한 여백
export const SearchSpacer = () => { 
    return (<div className="w-full h-[1px] flex-shrink-0 flex-basis-full"></div>); 
}

export type FlexFormBreakProps = {
	className?: string;
	/** flex-direction: row + flex-wrap 일 때만 true. flex-col 안에서 basis-full 쓰면 주축(세로) 100%로 늘어나 레이아웃이 깨짐 */
	rowBreak?: boolean;
	/** 높이를 인라인으로 고정하면 flex가 임의로 늘리지 못함 */
	heightPx?: number;
};

/**
 * 세로 여백: grow-0·basis-auto로 flex 분배에 끌려 커지지 않게 함.
 * 높이가 클래스보다 커 보이면 heightPx={5} 처럼 지정.
 */
export const FlexFormBreak = ({
	className,
	rowBreak = false,
	heightPx,
}: FlexFormBreakProps) => {
	const sizeClass = heightPx != null ? className : (className ?? "h-[1px]");
	return (
		<div
			className={["w-full", "shrink-0", "grow-0", rowBreak ? "basis-full" : "basis-auto", "overflow-hidden", sizeClass]
				.filter(Boolean)
				.join(" ")}
			style={heightPx != null ? { height: heightPx, flexGrow: 0, flexShrink: 0 } : undefined}
			aria-hidden
		/>
	);
};

export const AggridDiv = ({ children, className = "" }: { children: React.ReactNode, className?: string }) => { return (<div className={`flex items-center justify-center gap-[12px] ${className}`}>{children}</div>); }


export const AggridInsertButton = memo(({ handleInsertClick }: { handleInsertClick: (e: MouseEvent<HTMLButtonElement>) => void }) => (
	<button className="bg-blue-500 text-white px-[4px] rounded-[4px]" onClick={handleInsertClick}>
		+
	</button>
));
AggridInsertButton.displayName = 'AggridInsertButton';

export const AggridRemoveButton = memo(({ handleRemoveClick }: { handleRemoveClick: (e: MouseEvent<HTMLButtonElement>) => void }) => (
	<button className="bg-red-500 text-white px-[4px] rounded-[4px]" onClick={handleRemoveClick}>
		-
	</button>
));
AggridRemoveButton.displayName = 'AggridRemoveButton';

export const AggridSwitchButton = (
	{ value, onChange, name, editable, titleless, wrapperOption }: 
	{ 
		value: 'Y' | 'N', 
		onChange: (name: string, newValue: 'Y' | 'N') => void,
		name: string,
		editable: boolean,
		titleless: boolean,
		wrapperOption: { wrapperStyle: string, titleStyle: string, inputStyle: string }
	}
) => (	
	<div className="flex items-center justify-center h-full">	
		{/* value : {value} */}
		<SwitchButtonForm
			value={value}
			onChange={onChange}
			name={name}
			editable={editable}
			titleless={titleless}
			wrapperOption={wrapperOption}
		/>
	</div>
);

export const AggridFileForm = (
	{ fileName, onChange, name, editable, titleless, wrapperOption, accept, onSelectClick, resultFileId, onDownloadClick }:
	{
		fileName: string,
		onChange: (name: string, fileName: string, fileData: string) => void,
		name: string,
		editable: boolean,
		titleless: boolean,
		wrapperOption: { wrapperStyle: string, titleStyle: string, inputStyle: string },
		accept?: string,
		onSelectClick?: () => void,
		resultFileId?: string,
		onDownloadClick?: () => void,
	}
) => (
	<div className="flex items-center justify-center h-full w-full">
		<FileForm
			fileName={fileName}
			onChange={onChange}
			name={name}
			editable={editable}
			titleless={titleless}
			wrapperOption={wrapperOption}
			accept={accept}
			onSelectClick={onSelectClick}
			resultFileId={resultFileId}
			onDownloadClick={onDownloadClick}
		/>
	</div>
);

export const BookMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth={1.5} fill="currentColor" {...props}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-3.152a.563.563 0 00-.652 0l-4.725 3.152a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
	</svg>
);
export const NonBookMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-3.152a.563.563 0 00-.652 0l-4.725 3.152a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
	</svg>
);

export const FileWithLinesIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<rect x="3" y="2" width="14" height="16" rx="2" stroke="#1D4ED8" strokeWidth="1.5"/>
		<line x1="6" y1="6" x2="14" y2="6" stroke="#1D4ED8" strokeWidth="1"/>
		<line x1="6" y1="9" x2="14" y2="9" stroke="#1D4ED8" strokeWidth="1"/>
		<line x1="6" y1="12" x2="12" y2="12" stroke="#1D4ED8" strokeWidth="1"/>
	</svg>
);

export const MaximizeIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<rect x="3" y="3" width="18" height="18" rx="1" />
	</svg>
);
export const RestoreIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<rect x="7" y="3" width="14" height="14" rx="1" />
		<rect x="3" y="7" width="14" height="14" rx="1" fill="currentColor" fillOpacity="0.15" />
	</svg>
);

// border-right: 1px solid #AEAEB2 !important;
export const SmallTitleSpan = ({ children }: { children: React.ReactNode }) => (
	<span className="w-full px-[8px] py-[2px] float-left text-black-900 font-bold hover:bg-blue-100"
		style={{ 
			borderTop: commonBorderString,
			borderLeft: commonBorderString,
			borderRight: commonBorderString 
		}}
	>
		{children}
	</span>
);


// 숫자 데이터용 정렬 스타일 (ex. 수량, 단가, 금액 등)
export const commonNumberCellStyle: CellStyle = {
	textAlign: 'right',
};
  
  // 코드류(공통코드, 품목코드 등) 정렬 스타일
export const commonCodeCellStyle: CellStyle = {
	textAlign: 'center',
};
  
  // 일반 텍스트 데이터용 정렬 스타일 (ex. 품명, 비고 등)
export const commonTextCellStyle: CellStyle = {
	textAlign: 'left',
};

// 순번 컬럼용 정렬 스타일
export const commonRowIndexCellStyle: CellStyle = {
	textAlign: 'center',
};


//(생산지시량 * 자품목bom소요량 / 모품목단위) * 손실률 + 고정손실량으로 총 소요량 계산
export const calculateTotalOrderQty = (orderQty: number, prntItemQty: number, childItemUsage: number, lossPercent: number, fixLossqty: number) => {
	return Math.ceil((orderQty * childItemUsage / prntItemQty) * (1 + lossPercent / 100) + fixLossqty);
}